import {Component, HostListener} from "@angular/core";
import {Platform} from "ionic-angular";
import {TranslateService} from "ng2-translate";
import {Local} from "./config-support/config";
import {StatusBar} from "@ionic-native/status-bar";
import {AuthService, LocalConfigurationService, VersionService} from "@fedelta-pos/data-client";
import {NotificationService} from "./notification/notification.service";
import {SessionModel} from "./orchestration/session.model";
import {CssVarHelper} from "./html-utils/css-var.helper";
import {LoadingStatus} from "./common-types/loading-status";
import {NavigationService} from "./orchestration/navigation.service";
import {OrchestrationEvents} from "./orchestration/orchestration-events";
import {ThemeModel} from "./theme/theme.model";
import {ResponsiveService} from "./orchestration/responsive.service";

@Component({
    selector: "ion-app",
    templateUrl: "./app.component.html"
})
export class MyApp {
    LoadingStatus = LoadingStatus;
    OrchestrationEvents = OrchestrationEvents;

    constructor(themeModel: ThemeModel,
                navigationService: NavigationService,
                responsiveService: ResponsiveService,
                versionService: VersionService,
                translate: TranslateService,
                authService: AuthService,
                notificationService: NotificationService,
                statusBar: StatusBar,
                platform: Platform,
                private localConfigurationService: LocalConfigurationService,
                public sessionModel: SessionModel) {
        const urlParams: URLSearchParams = new URLSearchParams(location.search);

        // Apply loading colors
        const cssVars: any = {};
        if (urlParams.has("bg")) {
            cssVars["--loadingBackground"] = "#" + urlParams.get("bg");
        }
        if (urlParams.has("fg")) {
            cssVars["--loadingForeground"] = "#" + urlParams.get("fg");
        }
        CssVarHelper.applyVars(document.documentElement, cssVars);

        translate.setDefaultLang("en");
        translate.getTranslation("en");
        translate.use(translate.getBrowserLang());

        versionService.requiredVersions$.throttleTime(1000).subscribe(() => {
            // noinspection JSIgnoredPromiseFromCall
            notificationService.displayAlert("woa.error.version.incompatible", "woa.error.version.upgrade");
        });

        authService.compatibility$.subscribe((compatible: boolean) => {
            if (!compatible) {
                // noinspection JSIgnoredPromiseFromCall
                notificationService.displayAlert("woa.error.version.incompatible", "woa.error.version.upgrade");
            }
        });

        if (responsiveService.isApp) {
            (async () => {
                await platform.ready();

                // Okay, so the platform is ready and our plugins are available.
                // Here you can do any higher level native things you might need.
                statusBar.overlaysWebView(false);
                statusBar.backgroundColorByHexString("#000000");
            })();
        }

        // Override appconfig.json settings from the appConfig param
        let appConfigParamStr: string = urlParams.get("appConfig");
        if (appConfigParamStr) {
            // Decode base64
            appConfigParamStr = atob(appConfigParamStr);

            const appConfigParam = JSON.parse(appConfigParamStr);
            if (appConfigParam.appId) {
                this.localConfigurationService.saveNumber(Local.APP_ID, appConfigParam.appId, true);
            }

            if (appConfigParam.loginToken) {
                this.localConfigurationService.saveString(Local.LOGIN_TOKEN, appConfigParam.loginToken, true);
            }

            if (appConfigParam.dataserverURL) {
                this.localConfigurationService.saveString(Local.DATASERVER_URL, appConfigParam.dataserverURL, true);
            }

            if (appConfigParam.previewToken) {
                this.sessionModel.previewToken = appConfigParam.previewToken;
                // Logout so the app will log in using the new token
                authService.logout();
            }
        }
    }

    /**
     * Listens for events originating from WBO sent against the embedded iframe to refresh the App
     * @param event MessageEvent
     */
    @HostListener("window:message", ["$event"])
    previewRefresh(event: MessageEvent) {
        if (this.sessionModel.previewToken && event && event.data && event.data.toString().startsWith("preview-refresh:")) {
            console.log("preview refresh");
            this.sessionModel.previewToken = event.data.toString().substring("preview-refresh:".length);
            this.localConfigurationService.saveString(Local.LOGIN_TOKEN, this.sessionModel.previewToken, true);
            // Load the App in preview mode which includes some preview data
            // noinspection JSIgnoredPromiseFromCall
            this.sessionModel.loadApp(true);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts